import React, { useState, useEffect } from 'react';
import {
  Modal, Box, IconButton, Typography, List, ListItem, ListItemIcon,
  ListItemText, Snackbar, SnackbarContent,
  Button
} from '@mui/material';
import {
  EmailShareButton, FacebookShareButton, TwitterShareButton,
   LinkedinShareButton, WhatsappShareButton,
  
} from 'react-share';

import ShareIcon from '@mui/icons-material/Share';
import LinkIcon from '@mui/icons-material/Link';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CheckIcon from '@mui/icons-material/Check';

interface SocialShareModalProps {
  title?: string;
  description?: string;
  url?: string;
}

interface SocialIcon {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  component?: any;
  props?: any;
}

const SocialShareModal: React.FC<SocialShareModalProps> = ({ 
  title = "", 
  description = "", 
  url 
}) => {
  const [open, setOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(url || window.location.href || "");
    }
  }, [url]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      setSnackbarOpen(true);
    }).catch(() => {
      console.log("Failed to copy");
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const socialIcons: SocialIcon[] = [
    { icon: <LinkIcon />, label: "Copy link", onClick: handleCopyLink },
    { 
      component: EmailShareButton, 
      icon: <EmailIcon />, 
      label: "Email",
      props: { 
        subject: title,
        body: `${description}\n\nCheck out this certificate: ${currentUrl}`
      }
    },
    { 
      component: FacebookShareButton, 
      icon: <FacebookIcon />, 
      label: "Facebook",
      // props: { hashtag: "#HRTalky" +title+` ${description}\n\nCheck out this certificate: ${currentUrl}` }
      props: { hashtag: "#HRTalky" }
    },
    { 
      component: TwitterShareButton, 
      icon: <TwitterIcon />, 
      label: "X",
      props: { title: title+` ${description}\n\nCheck out this certificate: ${currentUrl}`, hashtags: ['HRTalky', 'Certificate', 'Achievement'] }
    },
    // { 
    //   component: TelegramShareButton, 
    //   icon: <TelegramIcon />, 
    //   label: "Telegram",
    //   props: { title: title }
    // },
    { 
      component: LinkedinShareButton, 
      icon: <LinkedInIcon />, 
      label: "LinkedIn",
      props: { title: title+` ${description}\n\nCheck out this certificate: ${currentUrl}`, summary: description, source: "HR Talky Assessment Platform" }
    },
    { 
      component: WhatsappShareButton, 
      icon: <WhatsAppIcon />, 
      label: "Whatsapp",
      props: { title: `${title}\n\n${description}\n\n#HRTalky #Certificate #Achievement ${currentUrl}`, separator: "" }
    },
    // { 
    //   component: RedditShareButton, 
    //   icon: <RedditIcon />, 
    //   label: "Reddit",
    //   props: { title: title }
    // }
  ];

  return (
    <Box>
      <Button
              variant="contained"
              startIcon={ <ShareIcon />}
              onClick={handleOpen}
              sx={{
                px: 3,
                py: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
            Share Certificate
            </Button>
      {/* <IconButton 
        onClick={handleOpen} 
        aria-label="Open social share options"
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          px: 2,
          py: 1,
          borderRadius: 2,
          fontWeight: 600,
          '&:hover': {
            bgcolor: 'primary.dark',
          }
        }}
      >
        <ShareIcon sx={{ mr: 1 }} />
        <Typography variant="body2">
          Share Certificate
        </Typography>
      </IconButton> */}

      <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: 'absolute', 
          top: '50%', 
          left: '50%',
          transform: 'translate(-50%, -50%)', 
          width: 350,
          bgcolor: 'background.paper', 
          boxShadow: 24, 
          p: 4,
          borderRadius: '12px',
      '& .react-share__ShareButton':{
      // width:'0 !important'
      },
 '& .MuiListItemText-root':{
      
        width:'100% !important'
      },
      '& .MuiListItemText-root .MuiTypography-root':{
        // display:'flex',
        // justifyContent:'center',
        // alignItems:'center',
        // textAlign:'left !important'
        width:'100% !important'
      }
        }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, textAlign: 'center' }}>
            Share Certificate
          </Typography>
          <List>
            {socialIcons?.map((social, index) => {
              if (social.onClick) {
                return (
                  <ListItem 
                    key={index} 
                    onClick={social.onClick}
                    sx={{ 
                      borderRadius: 2, 
                      mb: 1,
                      cursor: 'pointer',
                      '&:hover': { bgcolor: 'action.hover' }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 36, mr: 1 }}>{social.icon}</ListItemIcon>
                    <ListItemText primary={social.label} />
                  </ListItem>
                );
              } else if (social.component) {
                const ShareButtonComponent = social.component;
                return (
                  <ListItem 
                    key={index}
                    sx={{ 
                      borderRadius: 2, 
                      mb: 1,
                      cursor: 'pointer',
                      '&:hover': { bgcolor: 'action.hover' },
                      p: 0
                    }}
                  >
                    <ShareButtonComponent 
                      url={currentUrl}
                      {...(social.props || {})}
                      style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        // width: '100%', 
                        padding: '8px 16px',
                        textDecoration: 'none',
                        color: 'inherit'
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 36, mr: 1 }}>{social.icon}</ListItemIcon>
                      <ListItemText primary={social.label} />
                    </ShareButtonComponent>
                  </ListItem>
                );
              } else {
                return null;
              }
            })}
          </List>
        </Box>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        action={
          <IconButton onClick={handleSnackbarClose} color="inherit">
            <CheckIcon />
          </IconButton>
        }
      >
        <SnackbarContent
          sx={{ bgcolor: 'success.main', color: 'white' }}
          message="Link copied to clipboard!"
        />
      </Snackbar>
    </Box>
  );
};

export default SocialShareModal;